import React, { useEffect, useState } from "react";
import TextInput from "../../Fields/TextInput";
import Validate from "../../../helpers/validate";
const { validateFastaInput } = Validate;

const countQuerySequences = (text) => {
    if (!text || text.length === 0 || text.startsWith('Paste your ')) return 0;

    const lines = text.split(/\r?\n/);
    const hasFastaHeader = lines.some((line) => line.trim().startsWith('>'));

    if (!hasFastaHeader) {
        return 1;
    }

    let count = 0;

    // If there is sequence content before the first FASTA header, count it as one sequence.
    let firstHeaderIndex = -1;
    for (let i = 0; i < lines.length; i++) {
        if (lines[i].trim().startsWith('>')) {
            firstHeaderIndex = i;
            break;
        }
    }

    if (firstHeaderIndex > 0) {
        const hasContentBeforeHeader = lines
            .slice(0, firstHeaderIndex)
            .some((line) => line.trim().length > 0);
        if (hasContentBeforeHeader) {
            count++;
        }
    }

    // Count FASTA entries that contain at least one non-header non-empty line.
    let hasOpenHeader = false;
    for (let i = 0; i < lines.length; i++) {
        const trimmed = lines[i].trim();
        if (trimmed.length === 0) continue;

        if (trimmed.startsWith('>')) {
            hasOpenHeader = true;
            continue;
        }

        if (hasOpenHeader) {
            count++;
            hasOpenHeader = false;
        }
    }

    return count;
};

const CMsearchQuery = (props) =>{
    
    const {formJson, setFormJson} = props

    const [errorString, setErrorString] = useState("")
    const [warningString, setWarningString] = useState("")
    const [labelString, setLabelString] = useState("Multiple Sequences allowed using FASTA format");
    const [edited, setEdited] = useState(false);
    const [queryCount, setQueryCount] = useState(0);

    // Expose queryCount to parent through formJson
    useEffect(() => {
        if (formJson && formJson.layout) {
            formJson.layout.queryCount = queryCount;
            setFormJson({...formJson}); // Trigger re-render in parent
        }
    }, [queryCount]);

    useEffect(()=>{
        if(formJson){
            if(formJson.searchInfo){
                if(formJson.searchInfo.qdb_seq == null){
                    formJson.searchInfo.qdb_seq = "";
                    setFormJson({...formJson})
                }
                
            }
        }
    },[formJson])

    useEffect(()=>{
        validateSequence(formJson.searchInfo.qdb_seq);
    },[formJson.searchInfo.qdb_seq_type])

    function validateSequence(seq){
        if (/<([a-zA-Z][a-zA-Z0-9]*)\b[^>]*>[\s\S]*?<\/\1>/i.test(seq)) {
            setErrorString("HTML tags are not allowed in the sequence input.");
            setWarningString("");
            if (!formJson.layout.errorIdList.includes("querySequence")) {
                formJson.layout.errorIdList.push("querySequence");
            }
            formJson.searchInfo.qdb_seq = seq.toUpperCase();
            setFormJson({...formJson});
            return;
        }
        let test = seq;
        test = test.toUpperCase();

        let anyErrors = false;
        let warningMsg = "";
        const lines = test.split(/\r?\n/);

        // Count sequences in real-time using shared function
        const count = countQuerySequences(test);
        if (count > 150) {
            setErrorString("Query sequence limit exceeded (150 sequences max)");
            anyErrors = true;
        }
        setQueryCount(count);

        if (!anyErrors) {
            const hasFasta = lines.some(line => line.trim().startsWith('>'));

            if (hasFasta) {
                // Duplicate ID (error) and duplicate content (warning) detection
                const fastaResult = validateFastaInput(test);
                if (fastaResult.error && !fastaResult.error.includes('cannot be empty')) {
                    setErrorString(fastaResult.error);
                    anyErrors = true;
                } else if (fastaResult.warning) {
                    warningMsg = fastaResult.warning;
                }
            } else if (/^\s*!!/.test(test)) {
                setErrorString("ST25 format is not supported.");
                anyErrors = true;
            } else if (/^\s*;/.test(test)) {
                // CIPO format — valid, allow through
            } else {
                // Plain text — reject EMBL format
                for (const line of lines) {
                    if (line.startsWith('//')) {
                        setErrorString("EMBL format is not supported.");
                        anyErrors = true;
                        break;
                    }
                }
            }
        }

        if (!anyErrors) {
            for (const line of lines) {
                if (/^>\s*[A-Z0-9_]+\s*$/.test(line)) continue;
                if (line.trim() === "" || line.trim().endsWith(",")) continue;

                switch (formJson.searchInfo.qdb_seq_type) {
                    case "protein":
                        if (/[\{\}]/g.test(line)) {
                            setErrorString("Invalid protein sequence");
                            anyErrors = true;
                        }
                        break;
                    case "nucleotide":
                        if (/[\{\}]/g.test(line)) {
                            setErrorString("Invalid nucleotide sequence");
                            anyErrors = true;
                        }
                        break;
                }
            }
        }

        if (test.trim() === "" && edited) {
            anyErrors = true;
            setErrorString("Please enter a query sequence");
            setLabelString("ATGC...");
        }

        if (anyErrors) {
            if (!formJson.layout.errorIdList.includes("querySequence")) {
                formJson.layout.errorIdList.push("querySequence");
            }
            setWarningString("");
        } else {
            const index = formJson.layout.errorIdList.indexOf("querySequence");
            if (index > -1) {
                formJson.layout.errorIdList.splice(index, 1);
            }
            setErrorString("");
            setWarningString(warningMsg);
        }

        formJson.searchInfo.qdb_seq = test;
        setFormJson({...formJson});
    }

    return(
        <>
        {!formJson.layout.isRedo &&
            <div className="form-group" style={formJson.layout.isRedo === false ? {paddingTop: "10px"} : {paddingTop:"10px", backgroundColor: "lightGrey", padding: "10px", borderRadius: "5px"}}>
                <TextInput 
                    spellcheck="false"
                    maxRows="8"
                    minRows="8"
                    multiline={true}
                    fullWidth
                    id="querySequence"
                    variant="outlined"
                    //value={formJson.searchInfo.qdb_seq}
                    onChange={(e)=>{
                        setEdited(true);
                       validateSequence(e.target.value);
                    }}
                    label={labelString}
                    error={formJson.layout.errorIdList.includes("querySequence") && edited}
                    helperText={errorString || warningString}
                    disabled={formJson.layout.isRedo === true}
                />
            </div>
        }
        </>
    )
}

export default CMsearchQuery